<template>
    <div id="addresspage">
        <div class="nav"><img src="../assets/img/箭头 (3).png" alt class="back" @click="goback" /> 收获地址管理 </div>
        <div class="containar">
            <div class="bgm" v-if="show">
                <div class="bgmLogo"><img src="../assets/img/空背景.png" alt=""></div>
                <div class="bgmText">您还没有添加地址</div>
            </div>
            <div class="addList" v-for="item in addressList" :key="item.id" v-else @click.stop="changeAddress(item)">
                <div>{{item.consignee}}&nbsp;&nbsp;&nbsp;{{item.mobile}} <span v-if="item.is_default==1?true:false">默认</span> </div>
                <p>{{item.province_name}}{{item.city_name}}{{item.district_name}}{{item.address}}</p>
                <img src="../assets/img/编辑.png" alt="" @click.stop="editAddress(item)">
            </div>
            <div class="addAddress">
                <div @click="editAddress">+添加地址 </div>
            </div>
        </div>
    </div>
</template>
<script>
import qs from "qs";
import {getAddList} from '@/api'
export default {
    data(){
        return{
            addressList:"", //用户收获地址列表
            show:false,
        }
    },
    created(){
        this.getAddress()
    },
    methods:{
        // 返回上个页面
        goback(){
            this.$router.go(-1)
        },
        // 获取地址列表
        async getAddress(){
            let token = window.localStorage.getItem('token')
            let params  = {
                token:token
            }
            let res = await getAddList(params)
            if(res.status===1){
                this.addressList = res.result
                if(this.addressList.length==0){
                    this.show = true
                }else{
                    this.show = false
                }
            }else if (res.status==-101){
                window.localStorage.removeItem("token");
                this.$router.push('/')
            }
        },
        // 编辑地址/添加新地址
        editAddress(item){
            this.$router.push({name:'editAddress',query:{detailinfo:item}})
        },
        // 点击切换地址信息
        changeAddress(info){
            window.sessionStorage.setItem('choseAddress',JSON.stringify(info))
            this.$router.go(-1)
        }
    }
}
</script>
<style lang="less" scoped>
#addresspage{
    width: 750px;
    height: 100vh;
    position: relative;
    font-size: 28px;
    .nav {
    width: 750px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    font-size: 26px;
    color: #000000;
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    .back {
      width: 15px;
      height: 27px;
      float: left;
      margin-top: 30px;
      margin-left: 31px;
    }
  }
  .containar{
        position: relative;
        height: 100vh;
        width: 100%;
        padding: 100px 30px 20px 30px;
        box-sizing: border-box;
        background-color: #f6f6f6;
        .bgm{
            width: 90%;
            position: absolute;
            top: 20%;
            text-align: center;
            .bgmText{
                margin: 20px 0;
                font-size: 40px;
            }

        }
        .addList{
            font-size: 28px;
            height: 150px;
            background-color: #fff;
            padding: 20px;
            border-radius: 20px;
            position: relative;
            margin-bottom: 20px;
            div{
                height: 60px;
                line-height: 60px;
                span{
                    display: inline-block;
                    margin: 0 10px;
                    width: 70px;
                    height: 35px;
                    line-height: 35px;
                    text-align: center;
                    padding: 0 5px;
                    border-radius: 20px;
                    color: #fff;
                    background-color: #FE0D07;
                }
                .active{
                    display: none;
                }
            }
            p{
                color: #9e9fa2;
                width: 500px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            img{
                position: absolute;
                width: 120px;
                height: 70px;
                top: 70px;
                right: 10px;
            }
        }
        .addAddress{
            position: absolute;
            bottom: 20%;
            left: 0;
            right: 0;
            width: 750px;
            height: 100px;
            div{
                height: 100px;
                line-height: 100px;
                width: 80%;
                margin: 0 auto;
                text-align: center;
                background-color: #FE0D07;
                color: #ffffff;
                border-radius: 50px;
                font-size: 26px;
            }
        }
    }
}
</style>